import React, { useEffect, useRef } from "react";
import Script from "next/script";
import classes from "./PrefSrcButton.module.scss";
import GoogleIcon from "../Icons/GoogleIcon";

interface PreferredSourceApi {
  init: (options: { theme: "light" | "dark"; lang: string }) => void;
  addPreferredSource: () => void;
}

declare global {
  interface Window {
    PREFERRED_SOURCE?: Array<(api: PreferredSourceApi) => void>;
  }
}

const FALLBACK_URL = "https://www.google.com/preferences/source?q=studies-overseas.com";

interface PrefSrcButtonProps {
  style?: React.CSSProperties;
  variant?: "outline" | "filled";
}

const PrefSrcButton = ({ style, variant = "outline" }: PrefSrcButtonProps) => {
  const apiRef = useRef<PreferredSourceApi | null>(null);

  useEffect(() => {
    window.PREFERRED_SOURCE = window.PREFERRED_SOURCE || [];
    window.PREFERRED_SOURCE.push((api) => {
      api.init({ theme: "light", lang: "en" });
      apiRef.current = api;
    });
  }, []);

  const handleClick = () => {
    if (apiRef.current) {
      apiRef.current.addPreferredSource();
      return;
    }
    window.open(FALLBACK_URL, "_blank", "noopener,noreferrer");
  };

  return (
    <>
      <Script id="google-preferred-sources" src="https://news.google.com/swg/js/v1/publisher.js" strategy="lazyOnload" preferred-sources-control="manual" />
      <button
        type="button"
        className={`${classes["prefSourceBtn"]} ${variant === "filled" ? classes["filled-btn"] : ""}`}
        style={style}
        onClick={handleClick}
      >
        <GoogleIcon />
        <span>Add KC as Preferred Source on Google</span>
      </button>
    </>
  );
};

export default PrefSrcButton;
